import { useEffect } from "react";

export default function TawkToChat() {
  useEffect(() => {
    // Create the Tawk.to configuration first
    const tawkScript = document.createElement("script");
    tawkScript.innerHTML = `
      window.Tawk_API = window.Tawk_API || {};
      window.Tawk_LoadStart = new Date();

      // Configure Tawk.to to appear on bottom right
      window.Tawk_API.onLoad = function(){
        // Show the chat widget
        window.Tawk_API.showWidget();

        // Set position to bottom right
        window.Tawk_API.setAttributes({
          'name': 'Customer Support',
          'email': 'support@qicino.com'
        });
      };

      // Auto-show the chat widget when page loads
      window.Tawk_API.onStatusChange = function(status){
        if (status === 'online') {
          window.Tawk_API.showWidget();
        }
      };
    `;

    // Add Tawk.to script
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://embed.tawk.to/5f7c826f4704467e89f52276/default";
    script.charset = "UTF-8";
    script.setAttribute("crossorigin", "*");

    // Append scripts to head
    document.head.appendChild(tawkScript);
    document.head.appendChild(script);

    // Add custom CSS to ensure proper positioning
    const styleSheet = document.createElement("style");
    styleSheet.textContent = `
      #tawk-bubble, .tawk-bubble {
        bottom: 20px !important;
        right: 20px !important;
        position: fixed !important;
        z-index: 999999 !important;
      }

      .tawk-widget-frame {
        bottom: 20px !important;
        right: 20px !important;
        position: fixed !important;
        z-index: 999998 !important;
      }
    `;
    document.head.appendChild(styleSheet);

    return () => {
      // Cleanup function to remove scripts and styles
      try {
        if (document.head.contains(script)) {
          document.head.removeChild(script);
        }
        if (document.head.contains(tawkScript)) {
          document.head.removeChild(tawkScript);
        }
        if (document.head.contains(styleSheet)) {
          document.head.removeChild(styleSheet);
        }
      } catch (error) {
        console.warn("Error removing TawkTo scripts:", error);
      }
    };
  }, []);

  return null; // This component doesn't render anything visible
}
